import { useCallback, useMemo, useState } from 'react'
import { ThreadDocumentsContext } from './threadDocumentsContextValue.js'

/**
 * Whether the thread's Documents panel is showing.
 *
 * Open state only — which thread is open comes from the layout context, so
 * switching threads keeps the panel up and swaps its contents.
 */
export function ThreadDocumentsProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  const openThreadDocuments = useCallback(() => setIsOpen(true), [])
  const closeThreadDocuments = useCallback(() => setIsOpen(false), [])
  const toggleThreadDocuments = useCallback(() => setIsOpen((open) => !open), [])

  const value = useMemo(
    () => ({ isOpen, openThreadDocuments, closeThreadDocuments, toggleThreadDocuments }),
    [isOpen, openThreadDocuments, closeThreadDocuments, toggleThreadDocuments],
  )

  return (
    <ThreadDocumentsContext.Provider value={value}>{children}</ThreadDocumentsContext.Provider>
  )
}
